<i18n src="@/locales/modules/RequestTranslate.json"></i18n>

<template>
	<CbsContextMenu
		v-if="
			request.can_cancel ||
			mixinIsCanCreateTodo ||
			isShowApproveOrRejectMenu ||
			request.is_owner && (request.is_reject || request.is_cancel)
		"
		v-bind="$attrs"
		:class="['request-context-menu', { 'mr-5': displayMode === 'detail', 'request-context-menu--is-can-approve-or-reject': isShowApproveOrRejectMenu }]"
		:menuListDataBinding="{ class: 'request-context-menu-list' }"
	>
		<div
			v-if="isShowApproveOrRejectMenu"
			class="request-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onClickAgree', request.id)"
		>
			<i class="nucleo mr-3 nucleo-c-check text-solid-green-1" />
			{{ $t("Actions.Agree") }}
		</div>

		<div
			divider
			v-if="isShowApproveOrRejectMenu"
			class="request-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onClickReject', request.id)"
		>
			<i class="nucleo mr-3 nucleo-c-remove-2 text-solid-red" />
			{{ $t("Actions.Reject") }}
		</div>

		<div
			v-if="displayMode === 'list' && request.is_owner && (request.is_reject || request.is_cancel)"
			class="request-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onClickRecreate', request)"
		>
			<i class="nucleo mr-3 nucleo-single-copy-04" />
			{{ $t("Actions.Recreate") }}
		</div>

		<div
			v-if="mixinIsCanCreateTodo"
			class="request-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onClickCreateTodo', request)"
		>
			<i class="nucleo mr-3 nucleo-cm-addtask" />
			{{ $t("CreateTodo") }}
		</div>

		<div
			class="request-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onClickDuplicate', request.id)"
		>
			<i class="nucleo mr-3 nucleo-duplicate-outline" />
			{{ $t("Actions.Duplicate") }}
		</div>

		<div
			class="request-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onClickDownload', request.id)"
		>
			<i class="nucleo mr-3 nucleo-file-download-94-2" />
			{{ $t("Actions.Download") }}
		</div>

		<div
			v-if="request.can_cancel"
			class="request-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onClickCancel', request.id)"
		>
			<i class="nucleo mr-3 nucleo-filter-remove" />
			{{ $t("CancelRequest") }}
		</div>
	</CbsContextMenu>
	<span v-else></span>
</template>

<script>
import {
	todoPermissions,
	requestPermissions,
	getUserPermissions
} from "@/mixins/mixins.js";

import CbsContextMenu from "@/components/cbs-context-menu/CbsContextMenu";

export default {
	name: "RequestContextMenu",
	mixins: [
		getUserPermissions({ ...todoPermissions, ...requestPermissions })
	],
	components: { CbsContextMenu },
	props: {
		request: {
			type: Object,
			required: true
		},
		displayMode: {
			type: String,
			default: "list",
			validator: prop => ["list", "detail"].includes(prop)
		}
	},
	emits: {
		onClickDownload: {},
		onClickDuplicate: {},
		onClickAgree: {},
		onClickReject: {},
		onClickCancel: {},
		onClickRecreate: {},
		onClickCreateTodo: {}
	},
	computed: {
		isShowApproveOrRejectMenu() {
			return this.displayMode === 'list' && this.request.can_edit;
		}
	}
};
</script>

<style lang="scss" scoped>
.request-context-menu {
	&.cbs-context-menu--horizontal ::v-deep .cbs-context-menu__btn-trigger {
		color: var(--color-gray-4);
	}
	&.request-context-menu--is-can-approve-or-reject {
		position: relative;

		&::after {
			position: absolute;
			top: -1px;
			left: 2px;
			content: "";
			width: 6px;
			height: 6px;
			display: block;
			background-color: var(--color-solid-red);
			border-radius: 100%;
		}
	}
}

.request-context-menu-list {
	.request-context-menu-list__item {
		font-size: 14px;

		i {
			font-size: 18px;
		}
	}
}
</style>
